import { COUNTRIES, countryFlagEmoji } from "@/data/countries";

export const COUNTRY_OPTIONS = COUNTRIES.map((country) => ({
  value: country.code,
  label: `${countryFlagEmoji(country.code)} ${country.name}`,
  name: country.name,
}));

export const USER_TABS = [{ key: "usersByDate", label: "Users", group: "user" }];

export const Y_DIMENSION_OPTIONS = [
  { value: "status", label: "Status" },
  { value: "countryCode", label: "Country" },
  { value: "gender", label: "Gender" },
  { value: "platform", label: "Platform" },
  { value: "activePlan", label: "Active plan" },
  { value: "ageGroup", label: "Age group" },
  { value: "signInBy", label: "Sign-in method" },
  { value: "verificationStatus", label: "Verification status" },
];

export const PLAN_TABS = [
  { key: "purchases", label: "Purchases", group: "plan" },
  {
    key: "wallet",
    label: "Wallet",
    dataKey: "walletTransactions",
    dateLabel: "Created at",
    group: "plan",
  },
];

export const COMPLAINT_TABS = [{ key: "complaints", label: "Complaints", group: "complaint" }];

export const MESSAGE_TABS = [{ key: "messages", label: "Messages", group: "message" }];

export const RELATION_TABS = [{ key: "relations", label: "Relations", group: "relation" }];

export const TABS = [
  ...USER_TABS,
  ...PLAN_TABS,
  ...COMPLAINT_TABS,
  ...MESSAGE_TABS,
  ...RELATION_TABS,
];

// One widget is rendered per entry — see DimensionWidget.vue.
export const COMPLAINT_DIMENSION_OPTIONS = [
  { value: "reporterType", label: "Reporter (system or user)" },
  { value: "status", label: "Status" },
  { value: "lastStatusActor", label: "Last status actor" },
  { value: "reason", label: "Reasons" },
  { value: "inPage", label: "In page" },
  { value: "aiSuggestedAction", label: "AI suggested action" },
  { value: "complianceRuleId", label: "Compliance rule" },
];

export const MESSAGE_DIMENSION_OPTIONS = [
  { value: "total", label: "Messages per day" },
  { value: "distinctAuthors", label: "Distinct authors per day" },
  { value: "type", label: "By type" },
  { value: "gotReadReceipt", label: "Got read receipt" },
  { value: "deleted", label: "Deleted" },
  { value: "seenByOther", label: "Seen by recipient" },
  { value: "repliedToAtom", label: "Replied to an atom" },
  { value: "repliedToMessage", label: "Replied to a message" },
];

export const RELATION_DIMENSION_OPTIONS = [
  { value: "type", label: "By type" },
  { value: "isSeen", label: "Seen" },
  { value: "hasAtomReference", label: "Has atom reference" },
];

// "Purchases & renewals" is one tab with a Type switch in the left column,
// rather than two separate tabs — both share the same dimension/metric/view
// controls and filters, and the backend already fetches both data sets
// together in one call, so there's nothing to refetch when switching.
export const PURCHASE_TYPE_OPTIONS = [
  { value: "purchases", label: "New purchases", dateLabel: "Acquired date" },
  { value: "renewals", label: "New & renewed plans", dateLabel: "From date" },
];

export const DATE_FIELD_OPTIONS = [
  { value: "createdAt", label: "Created at" },
  { value: "lastLoginAt", label: "Last login at" },
  { value: "deletedAt", label: "Deleted at" },
];

export const GRANULARITY_OPTIONS = ["day", "week", "month", "quarter", "year"];
export const DEFAULT_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const TIMEZONE_OPTIONS = ["Europe/Berlin", "Asia/Tehran", "UTC"];
export const STATUS_OPTIONS = ["active", "blocked", "deleted", "ghosted"];
export const GENDER_OPTIONS = [
  { value: "female", label: "Female" },
  { value: "male", label: "Male" },
  { value: "non_binary", label: "Non-binary" },
];
export const AGE_GROUP_OPTIONS = ["under_18", "18-24", "25-34", "35-44", "45-54", "55+"];
export const PLATFORM_OPTIONS = [
  { value: "ios", label: "iOS" },
  { value: "android", label: "Android" },
  { value: "not_specified", label: "Not specified" },
];
export const SIGN_IN_BY_OPTIONS = [
  { value: "phone", label: "Phone" },
  { value: "email", label: "Email" },
  { value: "apple", label: "Apple" },
  { value: "google", label: "Google" },
  { value: "telegram", label: "Telegram" },
  { value: "whatsapp", label: "WhatsApp" },
];
export const VERIFICATION_STATUS_OPTIONS = [
  { value: "waiting_for_review", label: "Waiting for review" },
  { value: "verified", label: "Verified" },
  { value: "rejected_code", label: "Rejected (code)" },
  { value: "rejected_selfie", label: "Rejected (selfie)" },
];
// One widget is rendered per entry on each tab — see DimensionWidget.vue.
export const PURCHASE_DIMENSION_OPTIONS = [
  { value: "addressCountry", label: "User country" },
  { value: "planName", label: "Plan" },
  { value: "gender", label: "User gender" },
  { value: "platform", label: "User platform" },
  { value: "ageGroup", label: "User age group" },
];
export const WALLET_DIMENSION_OPTIONS = [
  { value: "channel", label: "Channel" },
  { value: "platform", label: "User platform" },
  { value: "ageGroup", label: "User age group" },
];
export const AGE_MIN = 0;
export const AGE_MAX = 100;

export const dateRangeConfig = {
  mode: "range",
  dateFormat: "Y-m-d",
  maxDate: "today",
};

export const planLabel = (plan) => {
  const name = plan?.name || {};
  return name.EN || name.en || Object.values(name)[0] || plan?.id;
};
